import React, { useState, useMemo, useEffect } from 'react';
import { OptionsType } from '../../utils/customSelectUtils';
import { commonBackInfo, highlight } from '../../utils';
import CustomSelect from '../../components/CustomSelect';
import type { SingleCommonType } from '../../types';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { keyKolPlaceholder } from '../../constants/placeholder';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { formatFrontWebConfig } from '@op/hooks/useFrontWebConfig';

export default function KeyKOLSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  filterOptions,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');
  const { formatMessage } = useIntl();

  const formatFilterOptions = useMemo(() => {
    const data = formatFrontWebConfig(filterOptions);

    return data?.kol_accounts || {};
  }, [filterOptions]);

  function getOptions() {
    let list: Array<string> = [];
    try {
      list = Object.keys(formatFilterOptions);
    } catch (error) {}

    const result = list.map((item) => {
      return {  text: item,  value: item };
    });

    result.push({ text: formatMessage({ id: 'Other KOLs' }), value: '_system_other_kols_' });

    return result;
  }

  const options: OptionsType = useMemo(() => {
    const list = getOptions();

    if (searchValue.trim()) {
      const searchText = searchValue.toLocaleLowerCase();
      return list.filter((item) => {
        const text = item.text.toLocaleLowerCase();
        return text.includes(searchText);
      });
    } 
    return list;
  }, [formatFilterOptions, searchValue, formatMessage]);

  const basicOptions: OptionsType = useMemo(() => {
    return getOptions();
  }, [formatFilterOptions]); 

  const {
    selects: selectKeyKol,
    setSelects: setSelectKeyKol,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    oriDefaultFilter,
    defaultKey: 'key_kols',
    mustFilter: true,
    noneIsAll: true,
    options: basicOptions.map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  useEffect(() => {
    const [text, isAll] = getButtonElement(); 
    onChange?.(
      'key_kols',
      commonBackInfo(
        { key_kols: selectKeyKol },
        { keyKol: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [selectKeyKol, formatMessage]);

  const optionItemRender = (element: any) => { 
    return (
      <div className="dbo-select-channel-item">
        <span>{highlight(element, searchValue)}</span>
      </div>
    );
  };

  return (
    <div className={`kol-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={keyKolPlaceholder[lang]}
        options={options}
        basicOptions={basicOptions}  
        allLabel={formatMessage({ id: 'All' })}
        searchInfo={[searchValue, setSearchValue]}
        selectOptionsInfo={[selectKeyKol, setSelectKeyKol]}
        onClear={() => setSelectKeyKol([])}
        pointKey={FilterButtonPoint.keyKol}
        optionItemRender={optionItemRender}
      ></CustomSelect>
    </div>
  );
}
